/* product-accessories.js  (South Mini Splits)  v4
   - Robust JSON shape (array or single object)
   - Type-first grouping (ID→heuristics), then per-SKU only if different
   - MRCOOL companion expansion + numeric-insensitive fuzzy match
   - Line Sets: BTU-aware grouping + combined headings + chips filter
   - In-stock first; scoped hydration
*/
(function(){
  var ACC_TARGET_SEL = '#sms-accessories-target';
  var SOURCE_SEL = '#sms-techdata-source .tech-data-root, #sms-techdata-source.tech-data-root, #sms-acc-source .acc-root';

  function acc_sizedImage(url, w){
    try { var u=new URL(url); u.searchParams.set('width', w||240); return u.href; }
    catch(e){ return url; }
  }

  /* ---------------- boot ---------------- */
  function onReady(fn){
    if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', fn, {once:true});
    else fn();
  }
  onReady(function(){
    var tgt = document.querySelector(ACC_TARGET_SEL);
    if (!tgt) return;
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){
        if (es.some(e=>e.isIntersecting)){ io.disconnect(); ensureLoaded(); }
      }, {rootMargin:'0px', threshold:0.1});
      io.observe(tgt);
    } else ensureLoaded();
  });

  function ensureLoaded(){
    var src = document.querySelector(SOURCE_SEL);
    var tgt = document.querySelector(ACC_TARGET_SEL);
    if (!tgt) return;

    if (!src){
      tgt.innerHTML = '<p>No accessories available.</p>';
      return;
    }

    var jsonUrl    = src.getAttribute('data-techdata-json') || '';
    var prodSku    = src.getAttribute('data-techdata-prod-sku') || '';
    var rawVarSkus = src.getAttribute('data-techdata-variant-skus') || '[]';
    var variantSkus = safeParseJson(rawVarSkus);
    var wantedSkus  = normalizeAndDedupeSkus(prodSku, variantSkus);

    if (!jsonUrl){
      tgt.innerHTML = '<p>No accessories available.</p>';
      return;
    }

    tgt.innerHTML = '<p>Loading accessories…</p>';
    fetch(jsonUrl, {cache:'force-cache'})
      .then(r=>{ if(!r.ok) throw new Error('tecinfo.json '+r.status); return r.json(); })
      .then(function(raw){
        var db = normalizeDb(raw);
        renderAccessoriesTab(tgt, wantedSkus, db);
      })
      .catch(function(){ tgt.innerHTML = '<p>Accessories temporarily unavailable.</p>'; });
  }

  function normalizeDb(raw){
    if (Array.isArray(raw)) return raw;
    if (raw && Array.isArray(raw.items)) return raw.items;
    if (raw && Array.isArray(raw.records)) return raw.records;
    if (raw && typeof raw==='object') return [raw];
    return [];
  }

  /* ---------------- MRCOOL helpers ---------------- */
  function deriveMrCoolComponents(baseSku){
    var up = String(baseSku||'').toUpperCase();
    var parts = up.split('-');
    var hpIdx = parts.indexOf('HP');
    if (hpIdx === -1) return [];
    var head = parts.slice(0, hpIdx + 1);
    var tail = parts.slice(hpIdx + 1);
    function build(insert){ return [...head, insert, ...tail].join('-'); }
    return [build('C'), build('WMAH'), build('MUAH')];
  }
  function mrCoolFuzzyFind(headInsert, tailWanted, map){
    var prefix  = headInsert + '-';
    var wantKey = tailWanted.replace(/[0-9]/g,'');
    for (var upSku in map){
      if (!upSku.startsWith(prefix)) continue;
      var candKey = upSku.slice(prefix.length).replace(/[0-9]/g,'');
      if (candKey === wantKey) return map[upSku];
    }
    return null;
  }

  /* ---------------- TYPE MAP (by product_id) + heuristics ---------------- */
  var TYPE_ORDER = [
    'Line set covers',
    'Line Sets',
    'Wall Brackets / Condenser Pad',
    'Heat Kit',
    'Cleaning Kit',
    'Couplers',
    'Thermostat',
    'Conduit Cables',
    'Disconnect Box',
    'Rubber Feet Mounting Set',
    'Ground Stands',
    'Other Accessories'
  ];

  var ACC_TYPE_SETS = (function(){
    function S(arr){ return new Set(arr.map(String)); }
    return {
      'Line set covers': S([
        '7420475277427','7784329478259','8004649517171','8004667080819','8053617295475'
      ]),
      'Line Sets': S([
        '8056140103795','7347732283507','8014110228595','8014232748147','8014250672243',
        '8014258929779','8014268104819','8052349042803','8048835068019','8014321451123',
        '7347732283507','7871035375731','7871312920691','7347983646835','7871070437491',
        '7871408996467','7346828476531','7871160057971','7871417024627','7346841485427',
        '7347980533875','7871217598579','8037632344179','8036342694003','8036336730227',
        '8036351639667','8036331913331','8055997857907','8056020729971'
      ]),
      'Wall Brackets / Condenser Pad': S([
        '8111079882867','7855248081011','8004737138803','8004764401779','7850596696179',
        '8004698243187','7420483698803'
      ]),
      'Heat Kit': S([
        '7932186591347','7932195995763','7932199600243','7932201205875','7932202352755',
        '7992329470067','7992329994355','7992330780787','7992328749171','7842623127667',
        '7842622210163','7812784914547','7842621751411','8014096859251','8014095286387',
        '8014094467187','8014092697715','8014080573555'
      ]),
      'Cleaning Kit': S(['7855129690227']),
      'Couplers': S(['7855235006579','7855238676595']),
      'Thermostat': S(['7800311185523','8056167891059','8056169431155','8062486544499']),
      'Conduit Cables': S(['7850574938227']),
      'Disconnect Box': S(['7850581426291','8004678910067','7850578018419']),
      'Rubber Feet Mounting Set': S(['8004578836595']),
      'Ground Stands': S(['8004777836659','7784261976179','7784222031987'])
    };
  })();

  function getTypeForProductId(pid){
    if (!pid) return '';
    pid = String(pid).trim();
    for (var i=0;i<TYPE_ORDER.length;i++){
      var t = TYPE_ORDER[i];
      var set = ACC_TYPE_SETS[t];
      if (set && set.has(pid)) return t;
    }
    return '';
  }
  function classifyType(p){
    var pidType = getTypeForProductId(p && p.product_id);
    if (pidType) return pidType;

    var label = (p && (p.label||'')).toLowerCase();
    var handle = (p && p.handle)||'';
    var url = (p && p.url)||'';
    var path = (handle || acc_getHandleFromUrl(url) || '').toLowerCase();
    var s = label + ' ' + path;

    if (/\b(line[\s-]?set|installation kit|pre[-\s]?flared|copper)\b/.test(s) || /\b\d+ft\b/.test(s) || /1\/4|3\/8|1\/2|5\/8/.test(s)) return 'Line Sets';
    if (/\b(cover|duct|pvc)\b/.test(s) && /line/.test(s)) return 'Line set covers';
    if (/\b(bracket|wall bracket|condenser pad|pad)\b/.test(s)) return 'Wall Brackets / Condenser Pad';
    if (/\b(heat kit|heater|kw)\b/.test(s)) return 'Heat Kit';
    if (/\b(thermostat|smart.*stat)\b/.test(s)) return 'Thermostat';
    if (/\b(disconnect|fusible|non[-\s]?fusible)\b/.test(s)) return 'Disconnect Box';
    if (/\b(coupler|union)\b/.test(s)) return 'Couplers';
    if (/\b(conduit|cable|whip|data wire)\b/.test(s)) return 'Conduit Cables';
    if (/\b(clean|flush|coil cleaner)\b/.test(s)) return 'Cleaning Kit';
    if (/\b(rubber feet|anti[-\s]?vibration)\b/.test(s)) return 'Rubber Feet Mounting Set';
    if (/\b(stand|ground stand)\b/.test(s)) return 'Ground Stands';
    return 'Other Accessories';
  }

  /* ---------------- BTU helpers ---------------- */
  var BTU_KEYS = ['06','09','12','15','16','18','24','30','36','42','48','60'];
  function btuFromSpecs(specs){
    var raw = specs && (specs['Rated Capacity Btu/h'] || specs['Capacity (Btu/h)'] || '');
    var n = Number(String(raw).replace(/[^0-9.]/g,''));
    if (!n) return '';
    var k = Math.round(n/1000)*1000; // normalize 5950→6000
    return String(k);
  }
  function btuFromSku(sku){
    var up = String(sku||'').toUpperCase();
    // match 09/12 etc or 9000/12000
    var m = up.match(/(^|[^0-9])(06|09|12|15|16|18|24|30|36|42|48|60)([^0-9]|$)/);
    if (m) return padBtu(m[2]*1000);
    var m2 = up.match(/(6000|9000|12000|15000|16000|18000|24000|30000|36000|42000|48000|60000)/);
    if (m2) return String(m2[1]);
    return '';
  }
  function padBtu(n){ n=Number(n)||0; return String(n); }
  function prettyBtu(n){ n=Number(n)||0; return n.toLocaleString()+' BTU'; }
  function btuKeyFromRec(rec){
    return btuFromSpecs(rec.specs)||btuFromSku(rec.sku)||'';
  }

  /* ---------------- render ---------------- */
  function renderAccessoriesTab(target, wantedSkus, db){
    // Build lookup by UPPER SKU
    var map = Object.create(null);
    db.forEach(function(rec){
      if (!rec || !rec.sku) return;
      map[String(rec.sku).toUpperCase()] = rec;
    });

    // Expand wanted with MRCOOL companions; dedupe
    var allWanted = [];
    (wantedSkus||[]).forEach(function(s){
      if (!s) return;
      allWanted.push(s);
      deriveMrCoolComponents(s).forEach(function(c){ allWanted.push(c); });
    });
    var seen = Object.create(null);
    var wantedDedup = allWanted.filter(function(s){
      var up = String(s).toUpperCase();
      if (seen[up]) return false; seen[up]=1; return true;
    });

    // Resolve wanted → records (exact or fuzzy MRCOOL)
    var recs = [];
    var skuInfo = Object.create(null); // sku -> {rec, btu}
    wantedDedup.forEach(function(raw){
      var up = String(raw).toUpperCase();
      var rec = map[up];
      if (!rec){
        var parts = up.split('-');
        var hpIdx = parts.indexOf('HP');
        if (hpIdx>-1 && hpIdx<parts.length-1){
          var headInsert = parts.slice(0,hpIdx+2).join('-');
          var tailWanted = parts.slice(hpIdx+2).join('-');
          rec = mrCoolFuzzyFind(headInsert, tailWanted, map);
        }
      }
      if (rec && Array.isArray(rec.accessories) && rec.accessories.length){
        recs.push(rec);
        skuInfo[String(rec.sku)] = {rec:rec, btu:btuKeyFromRec(rec)};
      }
    });

    if (!recs.length){
      target.innerHTML = '<p>No accessories for this configuration.</p>';
      return;
    }

    // Build type-first buckets: { type: { sku: [products...] } }
    var buckets = Object.create(null);
    var skuOrder = [];
    recs.forEach(function(rec){
      var sku = String(rec.sku);
      skuOrder.push(sku);
      var prods = acc_normalizeList(rec.accessories);
      prods.forEach(function(p){
        var typ = classifyType(p);
        if (!buckets[typ]) buckets[typ] = Object.create(null);
        if (!buckets[typ][sku]) buckets[typ][sku] = [];
        buckets[typ][sku].push(p);
      });
    });
    skuOrder = Array.from(new Set(skuOrder)).sort();

    // Render types in fixed order if present
    var html = '';
    TYPE_ORDER.forEach(function(typ){
      var bySku = buckets[typ];
      if (!bySku) return;

      // Dedup within each SKU list by key
      var dedupedBySku = {};
      skuOrder.forEach(function(sku){
        var list = bySku[sku] || [];
        dedupedBySku[sku] = dedupeAccList(list);
      });

      html += '<div class="sms-acc-type"><h3 class="sms-acc-type-title">'+esc(typ)+'</h3>';

      if (typ === 'Line Sets'){
        html += renderLineSetsByBTU(dedupedBySku, skuInfo);
      } else {
        // Compare signatures across SKUs to decide if per-SKU split is needed
        var lists = skuOrder.map(function(sku){ return dedupedBySku[sku] || []; });
        var nonEmpty = lists.filter(function(l){ return l && l.length; });
        var sigs = nonEmpty.map(acc_signature).filter(Boolean);
        var uniqueSigs = Array.from(new Set(sigs));

        if (uniqueSigs.length <= 1){
          // identical across SKUs OR only one SKU has items → render the first non-empty list
          var list = nonEmpty[0] || [];
          html += list.length ? buildAccessoryCarousel(list)
                              : '<p class="sms-acc-type-empty">No items.</p>';
        } else {
          // differs by SKU → render per SKU
          skuOrder.forEach(function(sku){
            var list = dedupedBySku[sku];
            if (!list.length) return;
            var btu = skuInfo[sku] && skuInfo[sku].btu;
            var sub = btu ? ('For your '+esc(prettyBtu(btu))+' Indoor Head') : ('For '+esc(sku));
            html += '<h4 class="sms-acc-sku-subtitle">'+sub+'</h4>';
            html += buildAccessoryCarousel(list);
          });
        }

      }

      html += '</div>';
    });

    target.innerHTML = html || '<p>No accessories for this configuration.</p>';
    acc_hydrateCardsIn(target); // scoped hydration
    wireBtuChips(target);
  }

  /* ---------------- Line Sets BTU rendering ---------------- */
  function renderLineSetsByBTU(dedupedBySku, skuInfo){
    // Build BTU -> list, then group BTUs by identical signature
    var btuLists = Object.create(null); // btu -> list
    Object.keys(dedupedBySku).forEach(function(sku){
      var btu = (skuInfo[sku] && skuInfo[sku].btu) || '';
      if (!btu) return;
      btuLists[btu] = dedupedBySku[sku]; // last write wins; if multiple SKUs same BTU, lists should match
    });

    var groups = []; // [{btus:[...], list:[...], sig:'...'}]
    var sigToIdx = Object.create(null);
    Object.keys(btuLists).sort(function(a,b){return Number(a)-Number(b);}).forEach(function(btu){
      var list = btuLists[btu]||[];
      var sig = acc_signature(list);
      if (!sig){ return; }
      if (sigToIdx[sig]==null){
        sigToIdx[sig] = groups.length;
        groups.push({btus:[btu], list:list, sig:sig});
      } else {
        groups[sigToIdx[sig]].btus.push(btu);
      }
    });

    if (!groups.length){
      // Fall back to any SKU list if BTU parsing failed
      var any = Object.values(dedupedBySku).find(function(x){return (x||[]).length;}) || [];
      return any.length ? buildAccessoryCarousel(any) : '<p class="sms-acc-type-empty">No items.</p>';
    }

    // Chips row
    var allBtus = groups.flatMap(function(g){return g.btus;}).sort(function(a,b){return Number(a)-Number(b);});
    var chips = '<div class="sms-btu-chips" role="group" aria-label="Select indoor head size">';
    allBtus.forEach(function(b, i){
      chips += '<button type="button" class="sms-btu-chip'+(i===0?' is-active':'')+'" data-btu="'+esc(b)+'">'+esc(Number(b).toLocaleString())+' BTU</button>';
    });
    chips += '</div>';

    // Sections for each group; show first by default; headings merged when shared
    var body = '';
    groups.forEach(function(g, idx){
      var title = 'For your '+g.btus.map(function(b){return Number(b).toLocaleString();}).join(', ')+' BTU Indoor Head';
      body += '<section class="sms-btu-section" data-btu-set="'+esc(g.btus.join(','))+'" '+(idx===0?'':'hidden')+'>';
      body +=   '<h4 class="sms-acc-sku-subtitle">'+esc(title)+'</h4>';
      body +=   buildAccessoryCarousel(g.list);
      body += '</section>';
    });

    return chips + body;
  }

  function wireBtuChips(root){
    var chips = root.querySelectorAll('.sms-btu-chip');
    if (!chips.length) return;
    var sections = Array.from(root.querySelectorAll('.sms-btu-section'));
    root.addEventListener('click', function(e){
      var btn = e.target.closest('.sms-btu-chip');
      if (!btn) return;
      var btu = btn.getAttribute('data-btu');
      chips.forEach(function(c){ c.classList.toggle('is-active', c===btn); });
      sections.forEach(function(sec){
        var set = (sec.getAttribute('data-btu-set')||'').split(',');
        sec.toggleAttribute('hidden', set.indexOf(btu)===-1);
      });
    });
  }

  /* ---------------- utils: list equality, dedupe ---------------- */
  function keyForProd(p){
    return (p.product_id && String(p.product_id)) || p.handle || p.url || '';
  }
  function acc_signature(list){
    var keys = (Array.isArray(list)?list:[])
      .map(keyForProd)
      .filter(Boolean)
      .sort();
    return keys.join('|');
  }
  function dedupeAccList(arr){
    var out=[], seen=Object.create(null);
    (arr||[]).forEach(function(p){
      var k = keyForProd(p);
      if (!k || seen[k]) return;
      seen[k]=1; out.push(p);
    });
    return out;
  }

  /* ---------------- carousel + hydration ---------------- */
  function buildAccessoryCarousel(arr){
    var prods = acc_normalizeList(arr);
    if (!prods.length) return '';
    var h = '<div class="sms-acc-carousel" role="list">';
    prods.forEach(function(p, i){
      var lbl = esc(p.label || '');
      h += '<article class="sms-acc-card" role="listitem"'
        +    ' data-acc-idx="'+i+'" data-avail="1"'
        +    (p.handle?(' data-handle="'+esc(p.handle)+'"'):'')
        +    (p.product_id?(' data-product-id="'+esc(p.product_id)+'"'):'')
        +    (p.url?(' data-url="'+esc(p.url)+'"'):'')
        +  '>'
        +    '<div class="sms-acc-card-media sms-acc-loading"></div>'
        +    '<div class="sms-acc-card-body">'
        +      '<h5 class="sms-acc-card-title">'+lbl+'</h5>'
        +      '<div class="sms-acc-card-price"></div>'
        +      '<div class="sms-acc-card-variant"></div>'
        +      '<button type="button" class="sms-acc-add-btn" disabled>Loading…</button>'
        +    '</div>'
        +  '</article>';
    });
    h += '</div>';
    return h;
  }

  function acc_hydrateCardsIn(root){
    if (!root) return;
    root.querySelectorAll('.sms-acc-card').forEach(function(card){
      if (card.getAttribute('data-acc-hydrated')==='1') return;
      var handle = card.getAttribute('data-handle');
      var url    = card.getAttribute('data-url');
      acc_fetchProduct(handle).then(function(prod){
        acc_hydrateAccessoryCard(card, prod, url);
      });
    });
  }

  document.addEventListener('sms:acc:added', function(){
    if (window.__smsAccSourceMarked) return;
    window.__smsAccSourceMarked = true;
    try {
      var fd = new FormData();
      fd.append('attributes[acc_source]', 'acc_tab');
      fd.append('attributes[acc_source_ts]', new Date().toISOString());
      fetch('/cart/update.js', { method:'POST', body: fd, credentials:'same-origin' });
    } catch(_){}
  }, { passive: true, once: true });

  function acc_hydrateAccessoryCard(card, prod, fallbackUrl){
    card.setAttribute('data-acc-hydrated','1');
    var mediaEl   = card.querySelector('.sms-acc-card-media');
    var titleEl   = card.querySelector('.sms-acc-card-title');
    var priceEl   = card.querySelector('.sms-acc-card-price');
    var variantEl = card.querySelector('.sms-acc-card-variant');
    var btnEl     = card.querySelector('.sms-acc-add-btn');

    if (!prod){
      mediaEl.innerHTML = '';
      titleEl.innerHTML = fallbackUrl
        ? '<a href="'+fallbackUrl+'" target="_blank" rel="noopener">'+titleEl.textContent+'</a>'
        : titleEl.textContent;
      priceEl.textContent = '';
      btnEl.textContent   = fallbackUrl ? 'View' : 'Unavailable';
      btnEl.disabled      = !fallbackUrl;
      if (fallbackUrl) btnEl.addEventListener('click', function(){ window.open(fallbackUrl,'_blank'); });
      card.setAttribute('data-avail','1');
      acc_reorderCards(card.parentElement);
      return;
    }

    titleEl.innerHTML = '<a href="'+prod.url+'" target="_blank" rel="noopener">'+esc(prod.title)+'</a>';

    var imgSrc = (prod.images && prod.images[0]) ? acc_sizedImage(prod.images[0], 240) : '';
    mediaEl.classList.remove('sms-acc-loading');
    mediaEl.innerHTML = imgSrc ? '<img loading="lazy" src="'+imgSrc+'" alt="'+esc(prod.title)+'">' : '';

    var variants = Array.isArray(prod.variants)?prod.variants:[];
    if (variants.length <= 1){
      variantEl.innerHTML = '';
    } else {
      var sel = '<label><span class="visually-hidden">Select</span><select class="sms-acc-var-sel">';
      variants.forEach(function(v){
        sel += '<option value="'+v.id+'" '+(v.available?'':'disabled')+'>' + esc(v.title) + (v.available?'':' (Sold Out)') + '</option>';
      });
      sel += '</select></label>';
      variantEl.innerHTML = sel;
    }

    var initVar = variants.find(function(v){return v.available;}) || variants[0] || null;
    if (initVar){
      priceEl.textContent = acc_formatMoney(initVar.price);
      btnEl.disabled = !initVar.available;
      btnEl.textContent = initVar.available ? 'Add to Cart' : 'Sold Out';
      btnEl.setAttribute('data-variant-id', initVar.id);
    } else {
      priceEl.textContent = '';
      btnEl.disabled = true;
      btnEl.textContent = 'Sold Out';
    }

    acc_setAvailAndResort(card, variants);

    if (variantEl.querySelector('select')){
      variantEl.querySelector('select').addEventListener('change', function(e){
        var vid = e.target.value;
        var v = variants.find(function(x){return String(x.id)===String(vid);});
        if (!v) return;
        priceEl.textContent = acc_formatMoney(v.price);
        btnEl.disabled = !v.available;
        btnEl.textContent = v.available ? 'Add to Cart' : 'Sold Out';
        btnEl.setAttribute('data-variant-id', v.id);
      });
    }

    btnEl.addEventListener('click', function(){
      var vid = btnEl.getAttribute('data-variant-id');
      if (!vid || btnEl.disabled) return;
      btnEl.disabled = true; btnEl.textContent = 'Adding…';
      acc_addToCart(vid, 1, { _acc_from_tab: '1' }).then(function(ok){
        btnEl.disabled = false;
        btnEl.textContent = ok ? 'Added!' : 'Error';
        if (ok) document.dispatchEvent(new CustomEvent('sms:acc:added', {detail:{variant_id:vid}}));
      });
    });
  }

  function acc_reorderCards(listEl){
    if (!listEl) return;
    var cards = Array.from(listEl.querySelectorAll(':scope > .sms-acc-card'));
    cards.sort(function(a,b){
      var av = Number(b.getAttribute('data-avail')||'1') - Number(a.getAttribute('data-avail')||'1');
      return av || 0;
    });
    cards.forEach(function(c){ listEl.appendChild(c); });
  }
  function acc_setAvailAndResort(card, variants){
    var isAvail = Array.isArray(variants) && variants.some(function(v){ return !!v.available; });
    card.setAttribute('data-avail', isAvail ? '1' : '0');
    acc_reorderCards(card.parentElement);
  }

  /* ---------------- utils ---------------- */
  function safeParseJson(raw){
    try { return JSON.parse(raw); }
    catch(_){
      try {
        var unescaped = String(raw||'').replace(/&quot;/g,'"').replace(/&#34;/g,'"').replace(/&amp;/g,'&');
        return JSON.parse(unescaped);
      } catch(__){ return []; }
    }
  }

  function normalizeAndDedupeSkus(prodSku, variantSkus){
    var set = Object.create(null);
    function add(s){ if(!s) return; set[s]=1; }
    add(prodSku);
    (variantSkus||[]).forEach(add);
    var raw = Object.keys(set);
    var cleaned=[];
    raw.forEach(function(sk){
      sk.split('+').forEach(function(part){
        var c = normalizeSkuPart(part);
        if(c) cleaned.push(c);
      });
    });
    var out=[], seen=Object.create(null);
    cleaned.forEach(function(sk){
      var up = sk.toUpperCase();
      if(!seen[up]){seen[up]=1;out.push(sk);}
    });
    return out;
  }
  function normalizeSkuPart(s){
    if(!s) return '';
    s = s.trim();
    s = s.replace(/^(\d+)\s*[xX]\s*[-_]?/, '');
    s = s.replace(/^[xX]\s*(\d+)\s*[-_]?/, '');
    s = s.replace(/[-_]?[xX]\s*\d+$/, '');
    s = s.replace(/\d+\s*[xX]$/, '');
    return s.trim();
  }

  function esc(str){
    return (''+str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function acc_getHandleFromUrl(u){
    if (!u) return '';
    try {
      var url = new URL(u, window.location.origin);
      var segs = url.pathname.split('/').filter(Boolean);
      var ix = segs.indexOf('products');
      if (ix>-1 && segs[ix+1]) return segs[ix+1];
      return segs.pop() || '';
    } catch(e){ return ''; }
  }

  function detectUrl(str){
    if(!str) return '';
    str = String(str).trim();
    if(/^https?:\/\//i.test(str)) return str;
    if(/^www\./i.test(str)) return 'https://' + str;
    return '';
  }

  function acc_normalizeList(arr){
    if (!Array.isArray(arr) || !arr.length) return [];
    var out=[], seen=Object.create(null);
    function pushOne(lbl, url, pid){
      pid = pid ? String(pid).trim() : '';
      var key = pid || acc_getHandleFromUrl(url) || url;
      if (!key || seen[key]) return;
      seen[key]=1;
      out.push({ label: lbl||'', url: url||'', product_id: pid, handle: acc_getHandleFromUrl(url) });
    }
    arr.forEach(function(item){
      if (!item) return;
      if (typeof item === 'string'){ pushOne(item, detectUrl(item), ''); return; }
      if (typeof item === 'object'){
        var lbl = item.label || item.title || item.name || '';
        var url = item.url || item.link || item.href || item.product_url || '';
        var pid = item.product_id || item.id || '';
        pushOne(lbl, url, pid);
        if (Array.isArray(item.alt_products)){
          item.alt_products.forEach(function(ap){ if (ap) pushOne(lbl, ap.url || '', ap.product_id || ''); });
        }
      }
    });
    return out;
  }

  var acc_productCache = Object.create(null);
  function acc_fetchProduct(handle){
    if (!handle) return Promise.resolve(null);
    if (acc_productCache[handle]) return acc_productCache[handle];
    acc_productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin'})
      .then(function(r){ if(!r.ok) throw new Error(handle+' '+r.status); return r.json(); })
      .catch(function(){ return null; });
    return acc_productCache[handle];
  }

  function acc_formatMoney(cents){
    if (typeof Shopify!=='undefined' && Shopify.formatMoney){
      try { return Shopify.formatMoney(cents, Shopify.money_format || "${{amount}}"); } catch(e){}
    }
    return '$' + (cents/100).toFixed(2);
  }

  function acc_addToCart(variantId, qty, props){
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', qty || 1);
    if (props && typeof props === 'object'){
      for (var k in props){
        if (Object.prototype.hasOwnProperty.call(props, k)){
          fd.append('properties[' + k + ']', String(props[k]));
        }
      }
    }
    return fetch('/cart/add.js', { method:'POST', body: fd, credentials:'same-origin' })
      .then(function(r){ return r.ok; })
      .catch(function(){ return false; });
  }

})();
